import { Route, Routes } from "react-router-dom";
import { PeriodGatePage } from "./index";

export default function PeriodGateRoutes() {
  return (
    <Routes>
      <Route path="/" element={<PeriodGatePage />} />
    </Routes>
  );
}
